import { AxiosError } from 'axios';
import { Tenant } from '../models/Tenant';
import { HTTPClient } from './httpClient';
const http = new HTTPClient(import.meta.env.VITE_TENANCY_API);

export interface Fulfiller {
  supplierBusinessUnitId: string;
  supplierBusinessUnitName: string;
  supplierFulfillerId: string;
  supplierFulfillerName: string;
  supplierFulfillmentLocationId: string;
  supplierFulfillmentLocationName: string;
  supplierTimeZone: string;
  fulfillmentTenantKey: string;
  fulfillmentDisplayName: string;
  fulfillmentCometAccountId: string;
  supplierAddress: Record<string, unknown>;
}

export async function fetchTenants(): Promise<Tenant[]> {
  try {
    const tenantsResponse = await http.get('');
    return tenantsResponse.map(
      (tenant: Fulfiller) =>
        ({
          fulfillerName: tenant.fulfillmentDisplayName,
          fulfillmentLocationId: tenant.supplierFulfillmentLocationId,
          fulfillmentLocationName: tenant.supplierFulfillmentLocationName,
          timeZone: tenant.supplierTimeZone,
          fulfillmentTenantKey: tenant.fulfillmentTenantKey,
          fulfillerId: tenant.supplierFulfillerId,
          fulfillmentCometAccountId: tenant.fulfillmentCometAccountId,
        }) as Tenant,
    );
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(error.message);
    }
  }
  return [];
}
